// Centralized error handling utility

export const handleGraphQLError = (error) => {
  console.error('GraphQL Error:', error);
  
  if (error.networkError) {
    const { statusCode } = error.networkError;
    
    switch (statusCode) {
      case 413:
        return {
          title: 'Request Too Large',
          message: 'The request is too large. Please try reducing the amount of data or contact support.',
          type: 'error'
        };
      case 401:
        return {
          title: 'Authentication Error',
          message: 'Your session has expired. Please log in again.',
          type: 'error'
        };
      case 403:
        return {
          title: 'Access Denied',
          message: 'You do not have permission to perform this action.',
          type: 'error'
        };
      case 500:
        return {
          title: 'Server Error',
          message: 'An internal server error occurred. Please try again later.',
          type: 'error'
        };
      default:
        return {
          title: 'Network Error',
          message: 'A network error occurred. Please check your connection and try again.',
          type: 'error'
        };
    }
  }
  
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    const graphQLError = error.graphQLErrors[0];
    
    if (graphQLError.extensions?.code === 'PAYLOAD_TOO_LARGE') {
      return {
        title: 'Request Too Large',
        message: 'The request is too large. Please try reducing the amount of data.',
        type: 'error'
      };
    }
    
    return {
      title: 'Error',
      message: graphQLError.message || 'An unexpected error occurred.',
      type: 'error'
    };
  }
  
  return {
    title: 'Unknown Error',
    message: 'An unexpected error occurred. Please try again.',
    type: 'error'
  };
};

export const showErrorNotification = (error) => {
  const errorInfo = handleGraphQLError(error);
  
  // For now, use console.error and alert
  // In a production app, you'd want to use a proper notification library
  console.error(`${errorInfo.title}: ${errorInfo.message}`);
  
  // You can replace this with a proper toast notification library
  if (typeof window !== 'undefined') {
    // Create a simple toast notification
    const toast = document.createElement('div');
    toast.className = 'fixed top-4 right-4 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 max-w-sm';
    toast.innerHTML = `
      <div class="flex items-center gap-2">
        <span class="material-icons-round text-sm">error</span>
        <div>
          <div class="font-semibold">${errorInfo.title}</div>
          <div class="text-sm opacity-90">${errorInfo.message}</div>
        </div>
      </div>
    `;
    
    document.body.appendChild(toast);
    
    // Remove toast after 5 seconds
    setTimeout(() => {
      if (document.body.contains(toast)) {
        document.body.removeChild(toast);
      }
    }, 5000);
  }
  
  return errorInfo;
};

export const handleMutationError = (error) => {
  const errorInfo = handleGraphQLError(error);
  showErrorNotification(error);
  return errorInfo;
};